module.exports = __webpack_public_path__ + "img/lucky_320.3d5fd8d9.png";